import React, { useState } from 'react'
import { EditorState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import { draftjsCustomToolbarConfigs } from '../shared/draftjsCustomToolbarConfigs'
import { initEditorState } from '../utils'

interface Props {
  element: any
  setElement: any
}

const TextContentEditor = (props: Props): JSX.Element => {
  const { element, setElement } = props
  const [editorState, setEditorState] = useState(
    initEditorState(element?.text_content)
  )

  return (
    <Editor
      editorState={editorState}
      editorClassName="custom-editor"
      localization={{
        locale: 'fr',
      }}
      onEditorStateChange={(editorState: EditorState) => {
        setEditorState(editorState)
      }}
      toolbar={draftjsCustomToolbarConfigs().articleToolbar}
      onBlur={() =>
        setElement({
          ...element,
          text_content: draftToHtml(
            convertToRaw(editorState.getCurrentContent())
          ),
        })
      }
    />
  )
}

export default TextContentEditor
